module.exports = __webpack_public_path__ + "static/media/interaction-toggle-checkmark-multi-select-on.3278ac24.svg";